import { Avatar, AvatarImage } from "@gigpro/ui/Avatar";
import { Button } from "@gigpro/ui/Button";
import { Dialog, DialogTitle } from "@gigpro/ui/Dialog";
import { Link } from "@tanstack/react-router";
import { useActiveLocationId } from "services/locationOrgContext";
import { getCloudinaryImage } from "utils/cloudinary";

type StartOnboardingDialogueProps = {
  open: boolean;
  onClose: () => void;
  proName: string;
  avatarUrl?: string | null;
};

export function StartOnboardingDialogue({ open, onClose, avatarUrl, proName }: Readonly<StartOnboardingDialogueProps>) {
  const [activeLocationId] = useActiveLocationId();
  return (
    <Dialog className="w-80" contentClassName="justify-center text-center" onClose={onClose} open={open}>
      <DialogTitle className="absolute top-4 right-4 bg-transparent" />
      <Avatar className="my-4 size-20 self-center">
        <AvatarImage src={avatarUrl ? getCloudinaryImage(avatarUrl).toURL() : undefined} />
      </Avatar>
      <b>To contact {proName} and other Pros we need some additional info</b>
      <p>Add your business and billing information in the following steps</p>
      <Button className="mt-4 w-full" variant="contained" asChild>
        <Link
          to="/signup"
          search={{
            // Un-onboarded user has no location yet — `-1` sentinel gets rewritten to
            // the user's first location by SignedUpGuard once signup completes.
            returnTo: `/locations/${activeLocationId ?? -1}/schedule`,
          }}
        >
          Continue to Business Onboarding
        </Link>
      </Button>
    </Dialog>
  );
}
